import { Component } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { SpinnyService } from './spinny/spinny.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  constructor(private router: Router, private spinny: SpinnyService) {
    router.events
      .filter(val => val instanceof NavigationStart || val instanceof NavigationEnd)
      .subscribe((val) => {
        if (val instanceof NavigationStart) {
          this.spinny.showSpinny();
        } else if (val instanceof NavigationEnd) {
          this.spinny.forceHideSpinny();
        }
      });

      document.title = environment.siteTitle;
  }
}
